import { render, staticRenderFns } from "./DatatableActions.vue?vue&type=template&id=74852c12"
import script from "./DatatableActions.vue?vue&type=script&lang=js"
export * from "./DatatableActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports